// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationCloseButton_container__2n065","close_icon":"NotificationCloseButton_close_icon__3Lxsf"};